import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup-body-modern" }
const _hoisted_2 = {
  class: "show-more-container",
  style: {"display":"flex","justify-content":"center","margin":"1px 0"}
}
const _hoisted_3 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_4 = { class: "form-footer footer-modern" }
const _hoisted_5 = {
  class: "footer-right",
  style: {"margin-top":"1px","text-align":"right"}
}
const _hoisted_6 = { class: "popup-body-modern" }
const _hoisted_7 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_8 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_9 = {
  class: "footer-right",
  style: {"margin-top":"10px","text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": _ctx.dsParteneri,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      height: "100%",
      onExporting: _ctx.onExporting,
      "hover-state-enabled": true,
      "remote-operations": true,
      onRowClick: _ctx.onRowClick,
      onContentReady: _ctx.onGridContentReady
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          savingTimeout: 100,
          "storage-key": "gridParteneriState"
        }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxPager, {
          "show-page-size-selector": true,
          "allowed-page-sizes": [5, 10, 20],
          "show-info": true,
          "show-navigation-buttons": true
        }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          "allow-search": true,
          title: "Selector coloane"
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxEditing, { "allow-updating": false }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Cauta Partener",
          "search-visible-columns-only": true
        }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": true,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "plus",
                  type: "success",
                  onClick: _ctx.onAddClick,
                  hint: "Adauga Partener"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick,
                  hint: "Reimprospateaza"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, { name: "exportButton" }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              "locate-in-menu": "auto",
              hint: "Alege Coloanele"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "searchPanel",
              "locate-in-menu": "auto"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, { "data-field": "Nume" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          visible: false
        }),
        _createVNode(_component_DxColumn, { "data-field": "CUI" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Fiscal",
          visible: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsParteneriFiscal,
              "value-expr": "Cod",
              "display-expr": "Nume"
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Client",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Furnizor",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Numar",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Strada",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Localitate",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "JudetID",
          visible: false,
          caption: "Judet"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsJudeteLookup,
              "value-expr": "ID",
              "display-expr": "Nume"
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TaraID",
          visible: false,
          caption: "Tara"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsTariLookup,
              "value-expr": "ID",
              "display-expr": "Nume"
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ZonaID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cont",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Banca",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Litigiu",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Extern",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Intern",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Observatii",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "faraScadenta",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValutaID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Director",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Fax",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Tel",
          visible: false,
          caption: "Telefon"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Email",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "www",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "GrupID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CP",
          visible: false,
          caption: "Cod Postal"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CStrada",
          visible: false,
          caption: "Strada Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CLocalitate",
          visible: false,
          caption: "Localitate Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CJudetID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CTaraID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CCP",
          visible: false,
          caption: "Cod Postal Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Bloc",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CBloc",
          visible: false,
          caption: "Bloc Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Numarstrada",
          visible: false,
          caption: "Numar Strada"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Scarabloc",
          visible: false,
          caption: "Scara Bloc"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CNumarstrada",
          visible: false,
          caption: "Numar Strada Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CScarabloc",
          visible: false,
          caption: "Scara Bloc Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Scadenta",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AgentID",
          caption: "Responsabil",
          visible: true,
          "allow-hiding": false,
          "allow-search": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsAgenti,
              "value-expr": "Id",
              "display-expr": "Nume"
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Angajat",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Memo",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CreditLimita",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DirectorEconomic",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "PersoanaContact",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AplicaTVAlaIncasare",
          visible: false,
          caption: "Aplica TVA la Incasare"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CifraAfacere",
          visible: false,
          caption: "Cifra Afacere"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NrAngajati",
          visible: false,
          caption: "Nr. Angajati"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Activ",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Owner",
          caption: "Owner",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CalculezPenalitati",
          visible: false,
          caption: "Calculez Penalitati"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ParRecomandareID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CapitalSocial",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AngajatID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ExternUE",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StructuraLegaturaID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "PartenerMasterID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "RegimSpecialTVA",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Et",
          visible: false,
          caption: "Etaj"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Ap",
          visible: false,
          caption: "Apartament"
        }),
        _createVNode(_component_DxColumn, { "data-field": "Adresa" }),
        _createVNode(_component_DxColumn, {
          "data-field": "CEt",
          visible: false,
          caption: "Etaj Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CAp",
          visible: false,
          caption: "Apartament Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CAdresa",
          visible: false,
          caption: "Adresa Corespondenta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CalculezPenalitatiDeLa",
          visible: false,
          caption: "Calculez Penalitati De La"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sufix",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Prefix",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Caen",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "PunctID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ParentID",
          visible: false,
          "show-in-column-chooser": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataCreare",
          visible: false,
          "show-in-column-chooser": true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "UserCreare",
          visible: false,
          "show-in-column-chooser": true
        })
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onRowClick", "onContentReady"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isPartnerModalVisible,
      width: 1450,
      height: 684,
      "show-title": true,
      title: "Adăugare Partener Nou",
      onHiding: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isPartnerModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[19] || (_cache[19] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare partener"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile partenerului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_DxForm, {
            ref: "newPartnerFormRef",
            "form-data": _ctx.newPartnerData,
            "col-count": 3,
            "col-span": 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Identitate & Fiscal",
                "col-count": 6,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CUI",
                    label: { text: 'CUI/CNP' },
                    "editor-options": _ctx.cuiOptions,
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'CUI/CNP' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Nume",
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Nume' este obligatoriu" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Fiscal",
                    "editor-type": "dxSelectBox",
                    "col-span": 4,
                    label: { text: 'Tip Fiscal' },
                    "editor-options": {
                                dataSource: _ctx.dsParteneriFiscal,
                                displayExpr: 'Nume',
                                valueExpr: 'Cod',
                                placeholder: 'Selectează Tip Fiscal',
                                searchEnabled: true,
                                onEnterKey: _ctx.onDropDownEnterKey
                            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Tip Fiscal' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numar",
                    label: { text: 'Regim Comerț' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Caen",
                    label: { text: 'Cod CAEN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Owner",
                    "editor-options": { readOnly: true },
                    label: { text: 'Responsabil' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Cont",
                    label: { text: 'IBAN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Grup *' },
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.GrupID,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPartnerData.GrupID) = $event)),
                        "data-source": _ctx.dsGrupuri,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        placeholder: "Selectează grupul",
                        "search-enabled": true,
                        "show-clear-button": true
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Zona *' },
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.ZonaID,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPartnerData.ZonaID) = $event)),
                        "data-source": _ctx.dsZona,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        placeholder: "Selectează zona",
                        "search-enabled": true,
                        "show-clear-button": true
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Memo",
                    "col-span": 6,
                    "editor-options": { height: 80 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Sediu Social",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Strada",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Bloc",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Et",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Ap",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Țara *' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.TaraID,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPartnerData.TaraID) = $event)),
                        "data-source": _ctx.dsTari,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează țara",
                        "search-enabled": true,
                        "show-clear-button": true,
                        onValueChanged: _ctx.onTaraChanged
                      }, null, 8, ["value", "data-source", "onValueChanged"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Județ *' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.JudetID,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPartnerData.JudetID) = $event)),
                        "data-source": _ctx.dsJudete,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează județul",
                        "search-enabled": true,
                        "show-clear-button": true
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Localitate",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Adresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Domiciliu Fiscal",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CStrada",
                    "col-span": 3,
                    label: { text: 'Strada' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CNumarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CBloc",
                    "col-span": 1,
                    label: { text: 'Bl.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CScarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CEt",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAp",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Țara' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.CTaraID,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newPartnerData.CTaraID) = $event)),
                        "data-source": _ctx.dsCTari,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează țara",
                        "search-enabled": true,
                        "show-clear-button": true,
                        onValueChanged: _ctx.onCTaraChanged
                      }, null, 8, ["value", "data-source", "onValueChanged"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Județ' },
                    "col-span": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxSelectBox, {
                        value: _ctx.newPartnerData.CJudetID,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPartnerData.CJudetID) = $event)),
                        "data-source": _ctx.dsCJudete,
                        "display-expr": "Nume",
                        "value-expr": "ID",
                        placeholder: "Selectează județul",
                        "search-enabled": true,
                        "show-clear-button": true
                      }, null, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CLocalitate",
                    "col-span": 3,
                    label: { text: 'Localitate' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CCP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAdresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "col-count": 3,
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_DxButton, {
                      "element-attr": { class: 'show-more-btn' },
                      text: _ctx.showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare',
                      icon: _ctx.showExtendedDetails ? 'chevronup' : 'chevrondown',
                      type: "normal",
                      "styling-mode": "text",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showExtendedDetails = !_ctx.showExtendedDetails))
                    }, null, 8, ["text", "icon"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Configurare Financiară & Comericală",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, { label: { text: 'Bancă (Internă)' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sBanci,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sBanci) = $event)),
                        "data-source": _ctx.dsBanci,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează bancă",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 },
                        "accept-custom-value": true,
                        onEnterKey: _ctx.onDropDownEnterKey,
                        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onDropDownSearchInput($event, 'dsBanci', 'Nume')))
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsBanci,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onBanciRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxGridToolbar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: _ctx.onAddNewBank
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source", "onEnterKey"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        opened: _ctx.isValutaGridBoxOpened,
                        "onUpdate:opened": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isValutaGridBoxOpened) = $event)),
                        "data-source": _ctx.valutaSelectat,
                        value: _ctx.sValuta,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.sValuta) = $event)),
                        "show-clear-button": true,
                        "display-expr": "Simbol",
                        "value-expr": "Id",
                        placeholder: "RON",
                        "accept-custom-value": true,
                        onEnterKey: _ctx.onDropDownEnterKey,
                        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onDropDownSearchInput($event, 'dsValuta', 'Simbol')))
                      }, {
                        content: _withCtx(({ data }) => [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsValuta,
                            "selected-row-keys": _ctx.sValuta ? [_ctx.sValuta] : [],
                            columns: ['Simbol'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onValueSelectedValuta($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ]),
                        _: 1
                      }, 8, ["opened", "data-source", "value", "onEnterKey"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "CapitalSocial" }),
                  _createVNode(_component_DxFormItem, { "data-field": "CifraAfacere" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "NrAngajati",
                    label: { text: 'Nr. Angajati' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AdaosPret",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scadenta",
                    label: { text: 'Termen de plată' },
                    "col-span": 1,
                    "editor-options": { readOnly: !_ctx.canEditLimiteCredit }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CreditLimita",
                    label: { text: 'Limita de credit' },
                    "col-span": 1,
                    "editor-options": { readOnly: !_ctx.canEditLimiteCredit }
                  }, null, 8, ["editor-options"])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Contacte & Diverse",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Tel",
                    label: { text: 'Telefon' }
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "Fax" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Email" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Director" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Observatii",
                    "col-span": 2,
                    "editor-options": { height: 100 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "System Flags",
                visible: _ctx.showExtendedDetails,
                "col-count": 2,
                "col-span": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTVAlaIncasare",
                    "editor-type": "dxCheckBox",
                    label: { text: 'TVA la Încasare' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "RegimSpecialTVA",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Intern",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: _ctx.handleInternChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Extern",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Extern Non UE' },
                    "editor-options": { onValueChanged: _ctx.handleExternChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "ExternUE",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Extern UE' },
                    "editor-options": { onValueChanged: _ctx.handleExternUEChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Client",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Furnizor",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Angajat",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Activ",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTvaDefalcat",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Split TVA' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "faraScadenta",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CalculezPenalitati",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Litigiu",
                    "editor-type": "dxCheckBox"
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_DxButton, {
                text: "Salvează Compania",
                type: "success",
                onClick: _ctx.onSaveNewPartner,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isPartnerModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isBankModalVisible,
      width: 800,
      height: 550,
      "show-title": true,
      title: "Adăugare Bancă",
      onHiding: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isBankModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[20] || (_cache[20] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare bancă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile băncii ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newBankData,
            "col-count": 2,
            "col-span": 2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, { "data-field": "Ordine" }),
              _createVNode(_component_DxFormItem, { "data-field": "Cod" }),
              _createVNode(_component_DxFormItem, { "data-field": "Nume" }),
              _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownBox, {
                    value: _ctx.sValute,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sValute) = $event)),
                    "data-source": _ctx.dsValute,
                    "display-expr": "Simbol",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "RON",
                    "content-template": "gridContent",
                    "accept-custom-value": true,
                    onEnterKey: _ctx.onDropDownEnterKey,
                    onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onDropDownSearchInput($event, 'dsValute', 'Simbol')))
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": _ctx.dsValute,
                          columns: ['Simbol'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: _ctx.onValuteRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxScrolling, { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onRowClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source", "onEnterKey"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, { "data-field": "CodIBAN" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodBIC" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodSWIFT" }),
              _createVNode(_component_DxFormItem, { "data-field": "TextFC" }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Principala",
                "editor-type": "dxCheckBox"
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Activ",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_DxButton, {
                text: "Salvează Banca",
                type: "success",
                onClick: _ctx.onSaveNewBank,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isBankModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}